'use es6';

import tinymce from 'tinymce';
import { HS_FORMATTING } from '../constants/plugins';
import { addFontSizeSelects } from './fontsize';
import { addFontSelects } from './font';
import { addLineheightSelects } from './lineheight';
import { addBlockSelect } from './block';
import { addFormattingControls } from './controls';
import { addAlignmentControls } from './alignment';
import { addListButtons } from './lists';
import { addIndentationControls } from './indent';
import { initCodeblockPlugin } from './codeblock';
import { initKeyboardEscapePlugin } from './keyboardEscape';
function formattingPlugin(editor) {
  addLineheightSelects(editor);
  addFontSelects(editor);
  addFontSizeSelects(editor);
  addBlockSelect(editor);
  addFormattingControls(editor);
  addAlignmentControls(editor);
  addListButtons(editor);
  addIndentationControls(editor);
  initCodeblockPlugin(editor);
  initKeyboardEscapePlugin(editor);
}
tinymce.PluginManager.add(HS_FORMATTING, formattingPlugin);